export const CHAT_STATUS_TYPE = {
    ACTIVE: 1,
    INACTIVE: 2,
    PAUSED: 3,
    SCHEDULED: 4,
    REPLAY: 5,
}